export const playBeepSound = () => {
  try {
    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = "sine";
    osc.frequency.setValueAtTime(1200, ctx.currentTime);
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.15);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start();
    osc.stop(ctx.currentTime + 0.15);
  } catch (e) {
    console.warn("Audio Context playback failed", e);
  }
};

export const triggerVibration = () => {
  if (typeof window !== "undefined" && "navigator" in window && navigator.vibrate) {
    try {
      navigator.vibrate([100, 30, 100]);
    } catch {
      // Ignore
    }
  }
};

export const sanitizeScannedBarcode = (text: string): string => {
  if (!text) return "";
  let clean = text.trim();
  if (clean.length >= 3 && clean.startsWith("*") && clean.endsWith("*")) {
    clean = clean.slice(1, -1);
  }
  clean = clean.replace(/[\x00-\x1F\x7F]/g, "");
  return clean;
};

export const getCameraStream = async (): Promise<MediaStream> => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    const isHttp =
      typeof window !== "undefined" &&
      window.location.protocol === "http:" &&
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "127.0.0.1";
    if (isHttp) {
      throw new Error(
        "Chrome requires HTTPS or localhost to access camera. Please use HTTPS or localhost."
      );
    }
    throw new Error("Camera API not supported in this browser context.");
  }

  const constraintOptions: MediaStreamConstraints[] = [
    {
      video: {
        facingMode: { ideal: "environment" },
        width: { ideal: 1920 },
        height: { ideal: 1080 },
        frameRate: { ideal: 30 },
      },
      audio: false,
    },
    {
      video: {
        facingMode: { ideal: "environment" },
        width: { ideal: 1280 },
        height: { ideal: 720 },
      },
      audio: false,
    },
    {
      video: { facingMode: "environment" },
      audio: false,
    },
    {
      video: { facingMode: { exact: "environment" } },
      audio: false,
    },
  ];

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter((d) => d.kind === "videoinput");
    const rearDevice = videoDevices.find(
      (d) =>
        d.label.toLowerCase().includes("back") ||
        d.label.toLowerCase().includes("rear") ||
        d.label.toLowerCase().includes("environment")
    );
    if (rearDevice && rearDevice.deviceId) {
      constraintOptions.unshift({
        video: { deviceId: { exact: rearDevice.deviceId } },
        audio: false,
      });
    } else if (videoDevices.length > 0) {
      const lastDevice = videoDevices[videoDevices.length - 1];
      if (lastDevice && lastDevice.deviceId) {
        constraintOptions.push({
          video: { deviceId: { exact: lastDevice.deviceId } },
          audio: false,
        });
      }
    }
  } catch {
    // Ignore device enumeration error
  }

  constraintOptions.push({ video: true, audio: false });

  let lastErr: any = null;
  for (const constraint of constraintOptions) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraint);
      if (stream) return stream;
    } catch (err) {
      lastErr = err;
    }
  }

  throw lastErr || new Error("Could not acquire camera stream.");
};
